import React from 'react';
import { Grid } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DyanamicDropdown from 'components/Elements/DyamicDropdown';
import { defectStatusTypes } from 'helpers/constants';
import { useFilters } from '../FilterContext';
import { useFilterInitialization } from './hooks/useFilterInitialization';
import { SHOW_ALL_OPTION } from '../constants';

export const DefectStatusTypeFilter = () => {
  const { filterValues, updateFilter } = useFilters();

  const {
		customCaptions
	} = JSON.parse(localStorage.getItem("me")) ||
	JSON.parse(sessionStorage.getItem("me"));
  
  // Format the defect status types for the dropdown
  const defectStatusTypeOptions = [
    SHOW_ALL_OPTION,
    { id: defectStatusTypes[0]?.value, name: defectStatusTypes[0]?.label },
    { id: defectStatusTypes[1]?.value, name: defectStatusTypes[1]?.label },
  ];

  // Clean, declarative initialization
  useFilterInitialization('defectStatusType', defectStatusTypeOptions, {
    waitForData: false,
    getDefaultValue: () => SHOW_ALL_OPTION,
    getParams: (item) => ({ defectStatusType: item.id })
  });

  if (!filterValues.defectStatusType) {
    return null;
  }

  return (
    <Grid item lg={3} md={6} xs={12}>
      <DyanamicDropdown
        dataSource={defectStatusTypeOptions}
        columns={[{ name: 'name', id: 1 }]}
        showHeader={false}
        width="100%"
        placeholder="Select Defect Status Type"
        onChange={item => updateFilter('defectStatusType', item, { defectStatusType: item.id })}
        selectdValueToshow="name"
        selectedValue={filterValues.defectStatusType?.value}
        label={`Filter by ${customCaptions?.defectStatus || 'Defect Status'} Type `}
        icon={<FilterListIcon style={{ color: 'rgb(48,122,215)' }} />}
        required={false}
        showBorderColor
      />
    </Grid>
  );
}; 
